import React from "react";
import cx from "clsx";

import ThreeSixtySvg from "@/images/home/hotspot-360.svg";
import NodeSvg from "@/images/home/hotspot-node.svg";

import styles from "./tourInstructions.module.scss";

const TourInstructions = (props) => {
  const { tourReady } = props;

  return (
    <div
      className={styles.instructions}
      style={{
        opacity: tourReady ? 1 : 0,
      }}
    >
      <div className={cx(styles.instructionText, styles.first)}>
        THIS IS A SCROLL-BASED EXPERIENCE
      </div>
      <div className={styles.instructionText}>
        PLEASE CONTINUE SCROLLING
        <br />
        TO EXPLORE ELCO YARDS
      </div>
      <div className={styles.instructions2}>
        <div className={styles.instructionText}>INTERACT WITH THESE ICONS</div>
        <div className={styles.instructionImg}>
          <ThreeSixtySvg alt="Three-sixty pano" />
        </div>
        <div
          className={cx(styles.instructionText, styles.small, styles.padding)}
        >
          CLICK FOR 360° VIEW
        </div>
        <div className={styles.instructionImg}>
          <NodeSvg width={40} height={40} alt="Node" />
        </div>
        <div className={cx(styles.instructionText, styles.small)}>
          HOVER FOR MORE INFO
        </div>
      </div>
    </div>
  );
};

export default TourInstructions;
